import React, { useMemo, useEffect } from 'react';
import styled from 'styled-components';

import Radio from 'antd/lib/radio';

import Admin from 'hive-admin';
import Field from 'hive-admin/src/components/Field';

import Types from '../modules/types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

// const Label = styled.span`
//   color: ${({ theme }) => theme.less.primaryColor};
//   /* margin-bottom: -15px; */
// `;

const Group = styled(Radio.Group)`
  display: flex;
  justify-content: center;
  white-space: nowrap;
  min-width: 100%;
`;

const GroupPlan = styled(Group)`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const Button = styled(Radio.Button)`
  height: auto;
  flex-shrink: 0;
  flex: 1;
`;

const ButtonPlan = styled(Button)`
  flex: 1;
`;

const PlanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 10px; */
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
  flex-shrink: 0;
  line-height: initial;
`;

// const PlanName = styled.div`
//   display: flex;
//   color: white;
//   background-color: ${({ theme }) => theme.less.textColor};
//   .ant-radio-button-wrapper-checked & {
//     background-color: ${({ theme }) => theme.less.primaryColor};
//   }
//   border-radius: 4px;
//   padding: 5px 10px;
//   line-height: 100%;
//   text-transform: uppercase;
//   font-weight: 600;
//   font-size: 10px;
//   padding-bottom: 4px;
// `;

const PlanPercentage = styled.div`
  color: ${({ theme }) => theme.less.textColor};
  .ant-radio-button-wrapper-checked & {
    color: ${({ theme }) => theme.less.primaryColor};
  }
  font-size: 38px;
  font-weight: 700;
  margin-top: 0px;
`;

const PlanPercentageLabel = styled.div`
  color: ${({ theme }) => theme.less.textColor};
  opacity: 0.5;
  .ant-radio-button-wrapper-checked & {
    opacity: 1;
    color: ${({ theme }) => theme.less.primaryColor};
  }
  font-size: 10px;
  font-weight: 400;
  margin-top: -2px;
`;

// const PlanPrice = styled.div`
//   color: ${({ theme }) => theme.less.textColor};
//   .ant-radio-button-wrapper-checked & {
//     color: ${({ theme }) => theme.less.primaryColor};
//   }
//   font-size: 14px;
//   font-weight: 400;
//   margin-top: 5px;
// `;

export function InputStoreSubscription({
  value,
  onChange,
  searchParams,
  form,
}) {
  const systemCountry = Types.SYSTEM_COUNTRY_MAP[
    form.getFieldValue('systemCountry')
    || searchParams.country
    || searchParams.sc
  ];
  const reseller = searchParams && `${searchParams.reseller}` === 'true';
  const subscriptions = useMemo(
    () => (
        !systemCountry
      ? null
      : systemCountry[(
          reseller
          ? 'subscriptionsReseller'
          : 'subscriptions'
        )]
    ),
    [systemCountry, reseller],
  );
  useEffect(
    () => {
      if (
        subscriptions
        && (
          !value
          || !subscriptions.SUBSCRIPTION_MAP[value]
      )) {
        onChange(
          subscriptions
          .SUBSCRIPTION_LIST
          .filter(item => !item.legacy)[0].id,
        );
      }
    },
    [subscriptions, value, onChange],
  );
  const [{ plan, duration }, choices] = useMemo(
    () => [
      (
        subscriptions
        ? subscriptions.SUBSCRIPTION_MAP[value] || {}
        : {}
      ),
      (
        subscriptions
        ? subscriptions.SUBSCRIPTION_LIST
        : []
      ).reduce(
        (agr, item) => {
          if (!item.legacy) {
            agr.map[`${item.duration}_${item.plan}`] = item;
            if (!agr.durations.includes(item.duration)) {
              agr.durations.push(item.duration);
            }
            if (!agr.plans.includes(item.plan)) {
              agr.plans.push(item.plan);
            }
          }
          return agr;
        },
        {
          map: {},
          durations: [],
          plans: [],
        },
      ),
    ],
    [value, subscriptions],
  );
  const makeChange = (durationInput, planInput) => {
    const item = choices.map[`${durationInput}_${planInput}`];
    // console.log('CHANGE:', item.id);
    onChange(item.id);
  };
  return (
    systemCountry && value
    ? (
        <Wrapper>
          {/* <Label>
            Choose your Billing / Plan:
          </Label> */}
          {
              choices.durations.length > 1
            ? (
                <>
                  <Group
                    value={duration}
                    buttonStyle="outline"
                    onChange={event => makeChange(event.target.value, plan)}
                    // TODO: Remove when implemented properly
                    className="hidden hack"
                  >
                    {
                      choices.durations.map(choiceDuration => (
                        <Button
                          key={choiceDuration}
                          value={choiceDuration}
                        >
                          {
                            Types.STORE_SUBSCRIPTION_DURATION_MAP[
                              choiceDuration
                            ].labelPeriodCharge
                          }
                        </Button>
                      ))
                    }
                  </Group>
                </>
              )
            : null
          }
          <GroupPlan
            value={plan}
            buttonStyle="outline"
            onChange={event => makeChange(duration, event.target.value)}
          >
            {
              choices.plans.map((label) => {
                const item = choices.map[`${duration}_${label}`];
                return (
                  <ButtonPlan
                    key={label}
                    value={label}
                  >
                    <PlanWrapper>
                      {/* <PlanName>{label}</PlanName> */}
                      <PlanPercentage>
                        {`${
                          systemCountry
                          ? `${systemCountry.currency} `
                          : ''
                        }${
                          item.price
                        }`}
                      </PlanPercentage>
                      <PlanPercentageLabel>
                        {`+ VAT / ${
                          item.durationLabel
                        }`}
                      </PlanPercentageLabel>
                      {/* <PlanPrice>
                        0% from sales
                      </PlanPrice> */}
                      {/* <PlanPrice>
                        {`${
                          systemCountry
                          ? `${systemCountry.currency} `
                          : ''
                        }${
                          Types.decimalize(
                               item.price
                            || item.annually
                            || item.monthly
                          )
                        }`}
                      </PlanPrice>
                      <PlanPercentageLabel>
                        {`+ VAT / ${
                          item.durationLabel
                        }`}
                      </PlanPercentageLabel> */}
                    </PlanWrapper>
                  </ButtonPlan>
                );
              })
            }
          </GroupPlan>
        </Wrapper>
      )
    : null
  );
}

export default class FieldStoreSubscription extends Field {
  static config = {
    ...Field.config,
    Component: InputStoreSubscription,
  }

  static inputPropsMap = {
    ...Field.inputPropsMap,
    form: true,
    searchParams: true,
  }
}

Admin.addToLibrary(
  'FieldStoreSubscription',
  config => FieldStoreSubscription.create(config),
);
